<template>
    <div>
        <div class="box box--white ssv-course-header">
            <div class="ssv-course-header__name">
                <h3>Dárkový poukaz - {{course.name}}</h3>
                <p>Termín a místo kurzu si zvolí obdarovaný.</p>
                <p>Platnost poukazu je 12 měsíců od vystavení.</p>
                <p>Po odeslání a zaplacení objednávky vám poukaz zašleme e-mailem.</p>
            </div>
            <div class="ssv-course-header__price">
                <div class="ssv-course-header__price-value">
                    {{course.priceVat}} Kč<br>
                </div>
                <div>
                    {{course.priceForNumberOfParticipants === 1 ? 'za osobu' : 'za kurz'}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';

    export default {
        name:     'SsvOrderHeaderGiftCard',
        computed: {
            ...mapGetters('ssvOrder', ['course']),
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/ssv-order/header/HeaderGiftCard.vue